import script from "./action-mote-clone.vue?vue&type=script&setup=true&lang=js"
export * from "./action-mote-clone.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__